import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { setDefaultSetting } from "../store";

export function useSyncPaysVateRateItem(
    paysVateRateData: any[],
    pays: any[],
    setPaysVateRateItem: (items: any[]) => void
) {
    useEffect(() => {
        setPaysVateRateItem(
            paysVateRateData.length > 0
                ? pays.filter(
                      (x: any) => paysVateRateData.indexOf(x.label) !== -1
                  )
                : []
        );
    }, [paysVateRateData, pays, setPaysVateRateItem]);
}

export function useInitVatRateForm(
    dataVatRate: any,
    setPaysVateRateData: (data: any) => void,
    setCodeVateRate: (code: string) => void,
    setVateRate: (rate: string) => void,
    setTagVateRateItem: (tags: any) => void
) {
    const { t } = useTranslation();

    useEffect(() => {
        if (dataVatRate?.Id !== undefined) {
            setPaysVateRateData(dataVatRate[t("Country")].labels);
            clearData();
            clearMultiCustomSelectionData();
            setCodeVateRate(dataVatRate.code.replace(",", "."));
            setVateRate(dataVatRate.value.replace(",", "."));
            setTagVateRateItem(dataVatRate.tag);
        }
    }, [
        dataVatRate,
        t,
        setPaysVateRateData,
        setCodeVateRate,
        setVateRate,
        setTagVateRateItem,
    ]);
}

export function useSyncDefaultSettingTva(data: any, defaultSetting: any) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            tva: { data: [...data.data] },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}

export function useFetchPays(
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>,
    i18nextLng: string,
    setPays: (pays: any[]) => void
) {
    const refreshPays = useCallback(async () => {
        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pays`;

        try {
            const data = await fetchGlobal<any>(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": i18nextLng,
                },
                method: "GET",
            });

            if (data.error) {
                throw Error("Error!");
            }

            let listOfTag: any = [];

            data.data.forEach((element: any) => {
                listOfTag.push({
                    label: element["Designation"],
                    value: element.Id,
                    frDesignation: element.frenchDesignation,
                });
            });
            setPays(listOfTag);

            mutate(apiUrl, data);
        } catch (e: any) {}
    }, [fetchGlobal, i18nextLng, setPays]);

    useEffect(() => {
        refreshPays();
    }, [refreshPays]);
}
